import Modal from "components/global/modal";
import { FaTimes } from "react-icons/fa";
import Zoom from "./media-button/zoom";
import React from "react";

const ImageModal = ({ hide, ...props }) => {
    const { source = null, viewUrl = "", isProfile = false } = props;
    const [isMobile, setIsMobile] = React.useState(false);
    const [viewportHeight, setViewportHeight] = React.useState(window.innerHeight-60);
    const [viewportWidth, setViewportWidth] = React.useState(window.innerWidth);


    const targetSize = viewportHeight < viewportWidth ? viewportHeight : viewportWidth;
    
    
    React.useEffect(()=>{
            // const userAgent = window.navigator.userAgent;
            // const mobileDevices = /Mobi|Android|iPhone|Ipad/;
            // setIsMobile(mobileDevices.test(userAgent)); 
            const isMobile = window.matchMedia("(max-width: 768px)").matches;
            setIsMobile(isMobile);
    
            const updateHeight = () => {
                setViewportHeight(window.innerHeight-60); // Dynamically adjust height
                setViewportWidth(window.innerWidth); 

              };
            
              // Add listeners for resize and orientation change
              window.addEventListener("resize", updateHeight);
              window.addEventListener("orientationchange", updateHeight);
            
              return () => {
                window.removeEventListener("resize", updateHeight);
                window.removeEventListener("orientationchange", updateHeight);
              };
        },[])
        
    return (
        <>
        {
            isProfile ? 
            <Modal
            width={`w-auto`}
            contentClassName="rounded-lg overflow-auto custom-style"
            wrapperClassName="overflow-visible custom-style "
            centerModal="flex items-center justify-center md:inline"
        >
            <div className={`${isProfile && "bg-black"}`}>
                <div className="flex-1 flex flex-col justify-center px-12 py-12 relative">
                    <div className="absolute z-9999 right-1 top-4 flex flex-row-reverse justify-between items-baseline mb-2">
                        <button onClick={() => hide()} className="mr-4">
                            <FaTimes className="text-white text-xl" />
                        </button>
                    </div>
                    <div className="image-zoom flex-1 flex flex-col">
                        <div className={`bg-black flex justify-center flex-1 rounded-md ${isProfile && "border-4 border-white"}`}>
                            <Zoom key={viewUrl || source}>
                                {({resetTransform}) => (
                                    <img
                                        src={viewUrl || source}
                                        className={`object-cover m-auto ${
                                            // isProfile ? "w-[400px]" : ""
                                            isProfile ? "" : ""
                                        }`}
                                        style={{ 
                                            opacity: 0, 
                                            transition: 'all 0.3s 0.25s',
                                            ...(isProfile && {
                                                width: targetSize - 180
                                            })
                                        }}
                                        alt="viewImage"
                                        onLoad={(e) => {
                                            /**
                                             * sometimes the library do not center the image 
                                             * when it's not done looading the image, so we trigger
                                             * resetTransform to recenter it after it's loaded
                                             */
                                            e.target.style.opacity = 1;
                                            typeof resetTransform === 'function' && resetTransform();
                                        }}
                                    />

                                )}
                            </Zoom>
                        </div>
                    </div>
                    <div className={`image-zoom-mobile rounded-md ${isProfile && "border-4 border-white"}`}>
                        <div className={`bg-black flex justify-center`}>
                            <img
                                src={viewUrl || source}
                                className={`image-zoom-mobile-image`}
                            
                                alt="viewImage"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
        :
        isMobile  ?
            <div className="">
                <Modal
                    mainContainer="bg-black"
                    width="3_1sm:w-[calc(100%_-_12rem)] w-[calc(100%_-_1rem)] h-[90vh]"
                    contentClassName="rounded-lg overflow-auto custom-style"
                    wrapperClassName=" custom-style sm:my-0"
                    image_gallery={true}
                >
                    <div className="flex flex-row justify-between items-baseline">
                        <p className="text-base text-white font-bold text-title flex-1">
                        </p>
                        <div className="flex justify-end">
                            <button onClick={() => hide()} className="mr-4">
                                <FaTimes className="text-white text-sm" />
                            </button>
                        </div>
                    </div>  
                        <div  className="bg-black flex justify-center flex-1">
                            <Zoom isMobile={true}>
                            {({resetTransform}) => (
                                <div className="relative w-full h-[90svh] flex">
                                    <img
                                        src={viewUrl || source }
                                        className="object-cove m-auto"
                                        style={{  maxHeight: `${viewportHeight}px`,
                                            width: `${viewportWidth}px`,
                                            opacity: 0, 
                                            transition: 'all 0.3s 0.25s', 
                                            userSelect: "none",
                                            pointerEvents: "none"
                                        }}
                                        alt={`milestone`}
                                        draggable="false" 
                                        onLoad={(e) => {
                                            e.target.style.opacity = 1;
                                            typeof resetTransform === 'function' && resetTransform();
                                        }}
                                    />
                                </div>
                            )}
                            </Zoom>
                        </div>
                </Modal>
            </div> 
            :<Modal
                // width="w-11/20 md:w-13/20 lg:w-14/20 xl:w-15/20"
                width="3_1sm:w-[calc(100%_-_8rem)] w-[calc(100%_-_1rem)]"
                contentClassName="rounded-lg overflow-auto custom-style"
                wrapperClassName="overflow-visible custom-style my-0"
                image_gallery={true}
            >
                <div className="">
                    <div className="flex flex-row items-baseline mb-1">
                        {/* close */}
                        <div className="flex-1 flex justify-end">
                            <button onClick={() => hide()} className="mr-4">
                                <FaTimes className="text-white text-xl" />
                            </button>
                        </div>
                    </div>
                    <div className="center bg-black min-h-[calc(100vh_-_5rem)] 3_1sm:min-h-[calc(98vh_-_2rem)]'} relative img-gallery flex items-center"> 
                        <div className=" flex justify-center flex-1">
                            <Zoom>
                                {({resetTransform}) => (
                                    <div className="w-[94vw] h-[95vh] flex">                                   
                                        <img
                                            src={viewUrl || source }
                                            className="object-cove m-auto"
                                            style={{ maxHeight: `${viewportHeight}px`, opacity: 0, 
                                                height: `${viewportHeight}px`,
                                                transition: 'all 0.3s 0.25s', 
                                                userSelect: "none",
                                                pointerEvents: "none"
                                            }}
                                            alt={`milestone`}
                                            draggable="false" 
                                            onLoad={(e) => {
                                                e.target.style.opacity = 1;
                                                typeof resetTransform === 'function' && resetTransform();
                                            }}
                                        />
                                    </div>
                                )}
                            </Zoom>
                        </div>
                    </div>
                </div>
            </Modal>
        }
        </>
        
    );
};

export default ImageModal;
